import type { SkillCatalogSkill } from "connected-components/skills/types"

const USER_SKILL_ID = /^user\/([0-9a-fA-F-]{36})$/
const VISIBLE_WITHOUT_SERVER_DECISION = new Set<SkillCatalogSkill["tier"]>(["user", "shared"])

export function canViewSkillFiles({ tier, sourceVisible }: Pick<SkillCatalogSkill, "tier" | "sourceVisible">): boolean {
  return sourceVisible ?? VISIBLE_WITHOUT_SERVER_DECISION.has(tier)
}

export function canDownloadSkill({ tier, sourceVisible }: Pick<SkillCatalogSkill, "tier" | "sourceVisible">): boolean {
  return sourceVisible === true && tier === "proprietary"
}

export function skillResourceId({ id }: Pick<SkillCatalogSkill, "id">): string | null {
  return USER_SKILL_ID.exec(id)?.[1] ?? null
}

export function canShareSkill(skill: Pick<SkillCatalogSkill, "tier" | "id">): boolean {
  return skill.tier === "user" && skillResourceId(skill) != null
}

export function canDeleteSkill(skill: Pick<SkillCatalogSkill, "tier" | "id">): boolean {
  return skill.tier === "user" && skillResourceId(skill) != null
}

export function canManageSkillShare(skill: Pick<SkillCatalogSkill, "tier">, role: string): boolean {
  return role === "admin" && skill.tier === "shared"
}
